"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/banner.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerFaSolidFaStar1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star me-1" */
    className?: string;
};

type BannerAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "border border-white" */
    imageWithBasePath0ClassName?: string;
};
export type HomeOneBannerGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "5.0 Ratings" */
    sectionDiv0Div0Div0Div0Div0Div1Div0P0PText?: ReactNode;
    /** Default: "5K+ Appointments" */
    sectionDiv0Div0Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0Div1DivDataWowDuration?: string;
    sectionDiv0Div0Div0Div0Div1Form0FormVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1Form0FormProps?: Partial<ComponentProps<"form">>;
    /** Default: "Search for Medical Procedures, hospitals" */
    sectionDiv0Div0Div0Div0Div1Form0Div1Div0Input0InputPlaceholder?: string;
    /** Default: "Search" */
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonText?: ReactNode;
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Discover Health: Find Your Trusted" */
    sectionDiv0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Doctors Today" */
    sectionDiv0Div0Div0Div0H10H1Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "img" */
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/video.svg" */
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkHref?: string;
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkHref?: string;
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "patient-image" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-doctor.svg" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-element-01.png" */
    sectionDiv1ImageWithBasePath0ImageSrc?: string;
    sectionDiv1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-element-02.png" */
    sectionDiv1ImageWithBasePath1ImageSrc?: string;
    sectionDiv1ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv1ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-element-03.png" */
    sectionDiv1ImageWithBasePath2ImageSrc?: string;
    sectionDiv1ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv1ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv1ImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-star.svg" */
    sectionDiv1ImageWithBasePath3ImageSrc?: string;
    sectionDiv1ImageWithBasePath3ImageVisible?: boolean;
    sectionDiv1ImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1ImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv1ImageWithBasePath4ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-star.svg" */
    sectionDiv1ImageWithBasePath4ImageSrc?: string;
    sectionDiv1ImageWithBasePath4ImageVisible?: boolean;
    sectionDiv1ImageWithBasePath4ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1ImageWithBasePath4ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv1ImageWithBasePath5ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-star.svg" */
    sectionDiv1ImageWithBasePath5ImageSrc?: string;
    sectionDiv1ImageWithBasePath5ImageVisible?: boolean;
    sectionDiv1ImageWithBasePath5ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1ImageWithBasePath5ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerFaSolidFaStar1s: BannerFaSolidFaStar1sItem[];
    bannerAvatarAvatarRoundeds: BannerAvatarAvatarRoundedsItem[];
    bannerFaSolidFaStar1sItemWrapper?: (item: BannerFaSolidFaStar1sItem, content: ReactNode) => ReactNode;
    bannerFaSolidFaStar1sRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerAvatarAvatarRoundedsItemWrapper?: (item: BannerAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    bannerAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerAvatarAvatarRoundedsImageVisible?: boolean;
    bannerAvatarAvatarRoundedsImageRenderer?: (item: BannerAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    bannerAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeOneBannerGenerated: FC<HomeOneBannerGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div1Div0P0PText = "5.0 Ratings",
    sectionDiv0Div0Div0Div0Div0Div1P0PText = "5K+ Appointments",
    sectionDiv0Div0Div0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Div1Form0Div1Div0Input0InputPlaceholder = "Search for Medical Procedures, hospitals",
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonText = "Search",
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonProps,
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H10H1Text = "Discover Health: Find Your Trusted",
    sectionDiv0Div0Div0Div0H10H1Text2 = "Doctors Today",
    sectionDiv0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt = "img",
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/video.svg",
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkHref = "#",
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div1Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkHref = "#",
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkVisible,
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkRenderer,
    sectionDiv0Div0Div1Div0Div0Div0Link1LinkProps,
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkHref = "#",
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkVisible,
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkRenderer,
    sectionDiv0Div0Div1Div0Div0Div0Link2LinkProps,
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "patient-image",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-doctor.svg",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv1ImageWithBasePath0ImageAlt = "img",
    sectionDiv1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-element-01.png",
    sectionDiv1ImageWithBasePath0ImageVisible,
    sectionDiv1ImageWithBasePath0ImageRenderer,
    sectionDiv1ImageWithBasePath0ImageProps,
    sectionDiv1ImageWithBasePath1ImageAlt = "img",
    sectionDiv1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-element-02.png",
    sectionDiv1ImageWithBasePath1ImageVisible,
    sectionDiv1ImageWithBasePath1ImageRenderer,
    sectionDiv1ImageWithBasePath1ImageProps,
    sectionDiv1ImageWithBasePath2ImageAlt = "img",
    sectionDiv1ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-element-03.png",
    sectionDiv1ImageWithBasePath2ImageVisible,
    sectionDiv1ImageWithBasePath2ImageRenderer,
    sectionDiv1ImageWithBasePath2ImageProps,
    sectionDiv1ImageWithBasePath3ImageAlt = "img",
    sectionDiv1ImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/banner-star.svg",
    sectionDiv1ImageWithBasePath3ImageVisible,
    sectionDiv1ImageWithBasePath3ImageRenderer,
    sectionDiv1ImageWithBasePath3ImageProps,
    sectionDiv1ImageWithBasePath4ImageAlt = "img",
    sectionDiv1ImageWithBasePath4ImageSrc = "/Templates/Doccure/img/bg/banner-star.svg",
    sectionDiv1ImageWithBasePath4ImageVisible,
    sectionDiv1ImageWithBasePath4ImageRenderer,
    sectionDiv1ImageWithBasePath4ImageProps,
    sectionDiv1ImageWithBasePath5ImageAlt = "img",
    sectionDiv1ImageWithBasePath5ImageSrc = "/Templates/Doccure/img/bg/banner-star.svg",
    sectionDiv1ImageWithBasePath5ImageVisible,
    sectionDiv1ImageWithBasePath5ImageRenderer,
    sectionDiv1ImageWithBasePath5ImageProps,
    sectionDiv0Div0Div0Div0Div1Form0FormVisible,
    sectionDiv0Div0Div0Div0Div1Form0FormRenderer,
    sectionDiv0Div0Div0Div0Div1Form0FormProps,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    bannerFaSolidFaStar1s,
    bannerAvatarAvatarRoundeds,
    bannerFaSolidFaStar1sItemWrapper,
    bannerFaSolidFaStar1sRenderer,
    bannerAvatarAvatarRoundedsItemWrapper,
    bannerAvatarAvatarRoundedsRenderer,
    bannerAvatarAvatarRoundedsImageVisible,
    bannerAvatarAvatarRoundedsImageRenderer,
    bannerAvatarAvatarRoundedsImageProps,
}) => {
    return (
        <section className="banner-section banner-sec-one">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-xl-7">
                        <div className="banner-content wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="rating-appointment">
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        bannerAvatarAvatarRoundeds,
                                        (item: BannerAvatarAvatarRoundedsItem) => (
                                            <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                {renderItemNode(bannerAvatarAvatarRoundedsImageVisible, bannerAvatarAvatarRoundedsImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "border border-white"} src={item.src} alt={item.alt ?? "img"} {...(typeof bannerAvatarAvatarRoundedsImageProps === "function" ? bannerAvatarAvatarRoundedsImageProps(item) : (bannerAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        bannerAvatarAvatarRoundedsItemWrapper,
                                        bannerAvatarAvatarRoundedsRenderer
                                    )}
                                </div>
                                <div>
                                    <p className="mb-1 avatar-ttile">{sectionDiv0Div0Div0Div0Div0Div1P0PText}</p>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center">
                                            {renderCollectionNode(
                                                bannerFaSolidFaStar1s,
                                                (item: BannerFaSolidFaStar1sItem) => (
                                                    <i className={item.className ?? "fa-solid fa-star me-1"} key={item.key} />
                                                ),
                                                bannerFaSolidFaStar1sItemWrapper,
                                                bannerFaSolidFaStar1sRenderer
                                            )}
                                        </div>
                                        <p className="rating ms-2">{sectionDiv0Div0Div0Div0Div0Div1Div0P0PText}</p>
                                    </div>
                                </div>
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0H10H1Renderer, (
                                <h1 className="title" {...(sectionDiv0Div0Div0Div0H10H1Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H10H1Text}
                                    {" "}
                                    <span className="banner-icon">
                                        {renderNode(sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </span>
                                    {" "}
                                    {sectionDiv0Div0Div0Div0H10H1Text2}
                                </h1>
                            ))}
                            <div className="search-box-one wow fadeInDown" data-wow-duration={sectionDiv0Div0Div0Div0Div1DivDataWowDuration}>
                                {renderNode(sectionDiv0Div0Div0Div0Div1Form0FormVisible, sectionDiv0Div0Div0Div0Div1Form0FormRenderer, (
                                    <form {...(sectionDiv0Div0Div0Div0Div1Form0FormProps ?? {})}>
                                        <div className="search-input search-line">
                                            <div className="select-item">
                                                <i className="isax isax-main-component5" />
                                                <div className="select" data-template-tag="CommonSelect" />
                                            </div>
                                        </div>
                                        <div className="search-input search-map-line">
                                            <i className="isax isax-search-normal" />
                                            <div className="mb-0">
                                                <input type="text" className="form-control" placeholder={sectionDiv0Div0Div0Div0Div1Form0Div1Div0Input0InputPlaceholder} />
                                            </div>
                                        </div>
                                        <div className="form-search-btn">
                                            {renderNode(sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonVisible, sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonRenderer, (
                                                <button className="btn btn-primary btn-primary-gradient" type="submit" {...(sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonProps ?? {})}>{sectionDiv0Div0Div0Div0Div1Form0Div2Button0ButtonText}</button>
                                            ))}
                                        </div>
                                    </form>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <div className="banner-img position-relative wow zoomIn" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            <div className="call-info">
                                <div className="call-item">
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div1Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div0Div1Div0Div0Div0Link0LinkHref} className="item-1 item" {...(sectionDiv0Div0Div1Div0Div0Div0Link0LinkProps ?? {})}>
                                            <i className="isax isax-video" />
                                        </SmartLink>
                                    ))}
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Div0Link1LinkVisible, sectionDiv0Div0Div1Div0Div0Div0Link1LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div0Div1Div0Div0Div0Link1LinkHref} className="item-2 item" {...(sectionDiv0Div0Div1Div0Div0Div0Link1LinkProps ?? {})}>
                                            <i className="isax isax-call-slash" />
                                        </SmartLink>
                                    ))}
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Div0Link2LinkVisible, sectionDiv0Div0Div1Div0Div0Div0Link2LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div0Div1Div0Div0Div0Link2LinkHref} className="item-3 item" {...(sectionDiv0Div0Div1Div0Div0Div0Link2LinkProps ?? {})}>
                                            <i className="isax isax-microphone-2" />
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="banner-bg">
                {renderNode(sectionDiv1ImageWithBasePath0ImageVisible, sectionDiv1ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionDiv1ImageWithBasePath0ImageSrc} alt={sectionDiv1ImageWithBasePath0ImageAlt} className="banner-element-01" {...(sectionDiv1ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionDiv1ImageWithBasePath1ImageVisible, sectionDiv1ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={sectionDiv1ImageWithBasePath1ImageSrc} alt={sectionDiv1ImageWithBasePath1ImageAlt} className="banner-element-02" {...(sectionDiv1ImageWithBasePath1ImageProps ?? {})} />
                ))}
                {renderNode(sectionDiv1ImageWithBasePath2ImageVisible, sectionDiv1ImageWithBasePath2ImageRenderer, (
                    <SmartImage src={sectionDiv1ImageWithBasePath2ImageSrc} alt={sectionDiv1ImageWithBasePath2ImageAlt} className="banner-element-03" {...(sectionDiv1ImageWithBasePath2ImageProps ?? {})} />
                ))}
                {renderNode(sectionDiv1ImageWithBasePath3ImageVisible, sectionDiv1ImageWithBasePath3ImageRenderer, (
                    <SmartImage src={sectionDiv1ImageWithBasePath3ImageSrc} alt={sectionDiv1ImageWithBasePath3ImageAlt} className="banner-element-04" {...(sectionDiv1ImageWithBasePath3ImageProps ?? {})} />
                ))}
                {renderNode(sectionDiv1ImageWithBasePath4ImageVisible, sectionDiv1ImageWithBasePath4ImageRenderer, (
                    <SmartImage src={sectionDiv1ImageWithBasePath4ImageSrc} alt={sectionDiv1ImageWithBasePath4ImageAlt} className="banner-element-05" {...(sectionDiv1ImageWithBasePath4ImageProps ?? {})} />
                ))}
                {renderNode(sectionDiv1ImageWithBasePath5ImageVisible, sectionDiv1ImageWithBasePath5ImageRenderer, (
                    <SmartImage src={sectionDiv1ImageWithBasePath5ImageSrc} alt={sectionDiv1ImageWithBasePath5ImageAlt} className="banner-element-06" {...(sectionDiv1ImageWithBasePath5ImageProps ?? {})} />
                ))}
            </div>
        </section>
    );
};

export default HomeOneBannerGenerated;
